var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pb-4",attrs:{"color":"#f7fafc"}},[_c('v-card-text',{staticStyle:{"background":"#e3e8ee"}},[_c('h4',{staticStyle:{"color":"#8992a2"}},[_vm._v(_vm._s(_vm.cardTitle))])]),_c('pre',{staticClass:"pl-6"},[_c('code',{staticStyle:{"background-color":"inherit"}},[_vm._v("\n"+_vm._s(_vm.jsonResponse)+"\n")]),_vm._v("\n")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }